import React, { Component } from "react";
import {
  get as _get, merge as _merge, isEmpty as _isEmpty, cloneDeep as _cloneDeep, set as _set, findLast as _findLast,
  isEqual as _isEqual, filter as _filter, reject as _reject, sortBy as _sortBy, findIndex as _findIndex
} from "lodash";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";

import { Select, ErrorMessage, showAlertMessage } from "../../../../resusableComponents/common/formElements";
import { withRouter } from "../../../../resusableComponents/hoc/withRouter";

import { updatePageLevelLoadingState } from "../../../../redux/actions/application";

import { doGetClientList } from "../../../../redux/services/userMangement";
import { getMasterColumnLists, getClientTemplateDetailsById, createOrUpdateTemplate } from "../../../../redux/services/clientTemplates";

// const concatenateTypeList = [
//   { id: 0, name: <FormattedMessage id="client_template.add.concat" defaultMessage="CONCAT" /> },
//   { id: 1, name: <FormattedMessage id="client_template.add.coalesce" defaultMessage="COALESCE" /> }
// ];

class AddOrUpdateTemplate extends Component {

  constructor(props) {
    super(props);

    this.defaultSimpleColumn = {
      prefix: "",
      columnName: null,
      friendlyName: "",
      isSpecial: false
    };

    this.defaultSpecialColumn = {
      concatType: "",
      friendlyName: "",
      columnFields: [{
        concatText: ",",
        columnName: []
      }],
      isSpecial: true
    };

    this.defaultInnerColumnFields = {
      concatText: "",
      columnName: []
    };

    this.defaultNoValue = {
      name: "",
      selectedAgency: [],
      selectedClient: [],
      simpleColumns: [],
      specialColumns: [],
      indexNo: 0,
      indexValue: 0,
      editTemplateData: [],
    };

    this.state = {
      ...this.defaultNoValue,
      masterColumnsList: [],
      activeRequestCount: 0,
      formError: {}
    };
  };

  componentDidMount() {
    this._fetchMasterColumnLists();
  };

  componentDidUpdate(prevProps, prevState) {
    if (!_isEqual(prevState.selectedAgency, this.state.selectedAgency) && !_get(this.props, "editTemplateId", null)) {
      this._fetchClientList();
    }
  };

  _incrementLoader = () => {
    const { updatePageLevelLoadingState } = this.props;
    this.setState((prevState) => {
      const nextCount = (_get(prevState, "activeRequestCount", 0) + 1);
      if (nextCount === 1 && typeof updatePageLevelLoadingState === "function") { updatePageLevelLoadingState(true); }
      return { activeRequestCount: nextCount };
    });
  }

  _decrementLoader = () => {
    const { updatePageLevelLoadingState } = this.props;
    this.setState((prevState) => {
      const nextCount = Math.max(0, _get(prevState, "activeRequestCount", 0) - 1);
      if (nextCount === 0 && typeof updatePageLevelLoadingState === "function") { updatePageLevelLoadingState(false); }
      return { activeRequestCount: nextCount };
    });
  }

  _fetchMasterColumnLists = async () => {
    const { editTemplateId } = this.props;

    try {
      this._incrementLoader();

      const response = await getMasterColumnLists();

      if ((response.flag || false) === true) {
        const masterColList = _get(response, "data.responseData", []);

        this.defaultSpecialColumn = {
          ...this.defaultSpecialColumn,
          concatType: { id: 0, name: <FormattedMessage id="client_template.manage_template.concat" defaultMessage="CONCAT" /> },
          columnFields: [{
            concatText: ",",
            columnName: _get(masterColList, "[0]", null)
          }]
        };

        this.defaultInnerColumnFields = {
          ...this.defaultInnerColumnFields,
          concatText: ",",
          columnName: _get(masterColList, "[0]", null)
        }

        this.setState({ masterColumnsList: masterColList }, () => {
          if (editTemplateId) {
            this._fetchTemplateDetailsByID();
          }
        });
      } else {
        showAlertMessage((_get(response, "message", "Something went wrong while fetching master field list.")));
      }
    } catch (error) {
      showAlertMessage(_get(error, "message", "Something went wrong while fetching master field list."));

    } finally {
      this._decrementLoader();
    }
  }

  _fetchClientList = async () => {
    const { selectedAgency } = this.state;

    try {
      this._incrementLoader();

      const response = await doGetClientList({ agency_id: _get(selectedAgency, "id", null), dropdown_flag: 1 });

      if ((response.flag || false) === true) {
        this.setState({ filterClientList: _get(response, "data.responseData.client_list", []), selectedClient: [] });
      } else {
        showAlertMessage((_get(response, "message", "Something went wrong while fetching client list.")));
        this.setState({ filterClientList: [], selectedClient: [] });
      }

    } catch (error) {
      showAlertMessage(_get(error, "message", "Something went wrong while fetching client list."));

    } finally {
      this._decrementLoader();
    }
  }

  _fetchTemplateDetailsByID = async () => {
    const { editTemplateId } = this.props;
    const { masterColumnsList } = this.state;

    try {
      this._incrementLoader();

      const response = await getClientTemplateDetailsById(editTemplateId);

      if ((response.flag || false) === true) {

        const editTemplateData = _get(response, "data.responseData", []);

        const tmpSimpleColumns = [];
        const tmpSpecialColumns = [];

        let tmpSelectedAgency = { id: _get(editTemplateData, "client_template[0].agency_id", null), agency_name: _get(editTemplateData, "client_template[0].agency_name", "") };
        let tmpSelectedClient = { id: _get(editTemplateData, "client_template[0].client_id", null), client_name: _get(editTemplateData, "client_template[0].client_name", "") };

        Object.values(editTemplateData.client_template_detail || []).forEach((e, i) => {

          // if (typeof e.simple_template === "object") {
          //   if (e.simple_template !== null) {
          // tmpSimpleColumns.push({
          //   prefix: _get(editTemplateData, `client_template_detail[${i}].simple_template.prefix`, []),
          //   columnName: _filter(masterColumnsList, (v) => (_isEqual(v.id, _get(editTemplateData, `client_template_detail[${i}].simple_template.column_id`, [])))),
          //   friendlyName: _get(editTemplateData, `client_template_detail[${i}]friendly_name`, []),
          //   displayOrder: _get(editTemplateData, `client_template_detail[${i}]display_order`, []),
          //   isSpecial: false
          // });

          tmpSimpleColumns.push({
            prefix: "",
            columnName: _filter(masterColumnsList, (v) => (_isEqual(v.id, _get(editTemplateData, `client_template_detail[${i}].client_template_field_lookup_id`, 0)))),
            friendlyName: _get(editTemplateData, `client_template_detail[${i}]friendly_name`, ""),
            displayOrder: _get(editTemplateData, `client_template_detail[${i}]sequence_number`, 1),
            isSpecial: false
          });
          //   }
          // }

          // if (typeof e.special_template === "object") {

          //   if (e.special_template !== null) {
          //     tmpSpecialColumns.push({
          //       concatType: _filter(concatenateTypeList, (v) => (_isEqual(v.id, _get(editTemplateData, `client_template_detail[${i}]special_template.special_type`, [])))),
          //       columnFields: (e.special_template.special_template_columns || []).map((f) => ({
          //         "columnName": _filter(masterColumnsList, (v) => (_isEqual(v.id, _get(f, "column_id", null)))),
          //         "concatText": _get(f, "concatenate_text", null)
          //       })),
          //       friendlyName: _get(editTemplateData, `client_template_detail[${i}]friendly_name`, []),
          //       displayOrder: _get(editTemplateData, `client_template_detail[${i}]display_order`, []),
          //       isSpecial: true
          //     });
          //   }
          // }
        });

        this.setState({
          name: _get(editTemplateData, "client_template[0].template_name", ""),
          selectedAgency: (tmpSelectedAgency || []),
          selectedClient: (tmpSelectedClient || []),
          simpleColumns: (tmpSimpleColumns || []),
          specialColumns: (tmpSpecialColumns || []),
          editTemplateData: (editTemplateData || []),
          indexNo: _get(editTemplateData, "client_template_detail", []).length,
          editTemplateId: (editTemplateId || null)
        });
      } else {
        showAlertMessage((_get(response, "message", "Something went wrong while fetching template details.")));
      }
    } catch (error) {
      showAlertMessage(_get(error, "message", "Something went wrong while fetching template details."));

    } finally {
      this._decrementLoader();
    }
  }

  _handleSubmit = async () => {
    const { setState, editTemplateId } = this.props;
    const { simpleColumns, name, /* specialColumns, editTemplateData, */ selectedClient } = this.state;

    let simplePayloadFormat = [];
    // let specialPayloadFormat = [];
    let latestSpecialPayload = [];
    let latestSimplePayload = [];
    let finalPayload = []

    simplePayloadFormat = _reject(_cloneDeep(simpleColumns || []), _isEmpty);
    // specialPayloadFormat = _reject(_cloneDeep(specialColumns || []), _isEmpty);

    const validForm = this._validateForm();

    if (!validForm) { return false; }

    if ((simplePayloadFormat || []).length > 0) {

      // latestSimplePayload = (simplePayloadFormat || []).map(e => ({
      //   "simple_template": {
      //     "column_id": (_get(e, "columnName[0].id", null) === null ? _get(e, "columnName.id", null) : _get(e, "columnName[0].id", null)),
      //     "prefix": (e.prefix || "")
      //   },
      //   "display_order": _get(e, "displayOrder", 0),
      //   "friendly_name": _get(e, "friendlyName", "")
      // }));

      latestSimplePayload = (simplePayloadFormat || []).map(e => ({
        "client_template_lead_field_lookup_id": (_get(e, "columnName[0].id", null) === null ? _get(e, "columnName.id", null) : _get(e, "columnName[0].id", null)),
        "sequence_number": _get(e, "displayOrder", 1),
        "friendly_name": _get(e, "friendlyName", "")
      }));
    }

    // if ((specialPayloadFormat || []).length > 0) {

    //   latestSpecialPayload = (specialPayloadFormat || []).map((e, i) => ({
    //     "special_template": {
    //       "special_type": (_get(e, "concatType[0].id", null) === null ? _get(e, "concatType.id", "") : _get(e, "concatType[0].id", null)),
    //       "special_template_columns": (e.columnFields || []).map((f) => ({
    //         "column_id": (_get(f, "columnName[0].id", null) === null ? _get(f, "columnName.id", null) : _get(f, "columnName[0].id", null)),
    //         "concatenate_text": _get(f, "concatText", "")
    //       }))
    //     },
    //     "display_order": _get(e, "displayOrder", 0),
    //     "friendly_name": _get(e, "friendlyName", "")
    //   }));
    // }

    finalPayload = _sortBy((latestSimplePayload || []).concat(latestSpecialPayload || []), ["display_order"]);

    try {
      this._incrementLoader();

      const payload = {
        client_id: (_get(selectedClient, "[0].id", null) === null ? _get(selectedClient, "id", "") : _get(selectedClient, "[0].id", null)),
        // agency_id: (_get(selectedAgency, "[0].id", null) === null ? _get(selectedAgency, "id", "") : _get(selectedAgency, "[0].id", null)),
        template_name: (name || ""),
        template_id: (editTemplateId || null),
        json: finalPayload
      };
      const response = await createOrUpdateTemplate(payload);

      if (_get(response, "flag", false) === true) {
        showAlertMessage(_get(response, "data.responseMessage", ""), "success");

        this.setState({ ...this.defaultNoValue, formError: {} });

        if (typeof setState === "function") {
          setState({
            showAddOrUpdateModal: false,
            selectedTemplateId: null,
            refreshTable: true
          });
        }
      } else {
        showAlertMessage((_get(response, "data.responseMessage", "Something went wrong while saving client template.")));
      }
    } catch (error) {
      showAlertMessage(_get(error, "data.responseMessage", "Something went wrong while saving client template."));

    } finally {
      this._decrementLoader();
    }
  }

  _validateForm = () => {
    const { intl } = this.props;
    const { name, selectedClient, selectedAgency, simpleColumns, specialColumns } = this.state;

    let manageTemplateColumn = _merge([], _cloneDeep(simpleColumns || []), _cloneDeep(specialColumns || []));

    let error = {};
    let allColumn = [];
    let duplicateValues = [];

    Object.values(simpleColumns || []).forEach(col => {
      const lowerFriendlyName = _get(col, "friendlyName", "").toLowerCase().trim();

      if (_isEmpty(lowerFriendlyName)) {
        error[`friendlyName-${(col.displayOrder || 0)}`] = intl.formatMessage({ id: "error.required", defaultMessage: "please enter {field}." },
          { field: intl.formatMessage({ id: "client_template.manage_template.friendly_name", defaultMessage: "friendly name" }) })
      }
      if (_isEmpty(col.columnName)) {
        error[`columnName-${(col.displayOrder || 0)}`] = intl.formatMessage({ id: "error.select", defaultMessage: "Please select {field}." },
          { field: intl.formatMessage({ id: "client_template.manage_template.column", defaultMessage: "column" }) })
      }

      if (!_isEmpty(lowerFriendlyName)) {
        if ((allColumn || []).includes(lowerFriendlyName) && !(duplicateValues || []).includes(lowerFriendlyName)) {
          duplicateValues.push(lowerFriendlyName);
        }
        if (!(allColumn || []).includes(lowerFriendlyName)) {
          (allColumn || []).push(lowerFriendlyName);
        }
      };
    });

    // Object.values(specialColumns || []).forEach(col => {
    //   const lowerSpecialFriendlyName = _get(col, "friendlyName", "").toLowerCase().trim();

    //   if (_isEmpty(lowerSpecialFriendlyName)) {
    //     error[`specialFriendly-${(col.displayOrder || 0)}`] = intl.formatMessage({ id: "error.required", defaultMessage: "please enter {field}." },
    //       { field: intl.formatMessage({ id: "client_template.manage_template.friendly_name", defaultMessage: "friendly name" }) })
    //   }

    //   if (!_isEmpty(lowerSpecialFriendlyName)) {
    //     if ((allColumn || []).includes(lowerSpecialFriendlyName) && !(duplicateValues || []).includes(lowerSpecialFriendlyName)) {
    //       duplicateValues.push(lowerSpecialFriendlyName);
    //     }
    //     if (!(allColumn || []).includes(lowerSpecialFriendlyName)) {
    //       (allColumn || []).push(lowerSpecialFriendlyName);
    //     }
    //   };
    // });

    if (_isEmpty(name)) {
      error["name"] = intl.formatMessage({ id: "error.required", defaultMessage: "please enter {field}." }, {
        field: intl.formatMessage({ id: "client_template.manage_template.input_name", defaultMessage: "name" })
      });
    }
    if (_isEmpty(selectedClient)) {
      error["selectedClient"] = intl.formatMessage({ id: "error.required", defaultMessage: "please enter {field}." }, {
        field: intl.formatMessage({ id: "client_template.manage_template.client", defaultMessage: "client" })
      });
    }
    if (_isEmpty(selectedAgency)) {
      error["selectedAgency"] = intl.formatMessage({ id: "error.required", defaultMessage: "please enter {field}." }, {
        field: intl.formatMessage({ id: "client_template.manage_template.agency", defaultMessage: "agency" })
      });
    }
    if ((manageTemplateColumn || []).length === 0) {
      error["template"] = showAlertMessage(intl.formatMessage({ id: "error.select_atleast_one", defaultMessage: "Please select at least one {field}." },
        { field: intl.formatMessage({ id: "client_template.manage_template.hermes_field", defaultMessage: "hermes fields" }) }
      ));
    }

    // if duplicate values exist show error message
    if ((duplicateValues || []).length > 0) {
      error["friendlyName"] = showAlertMessage(intl.formatMessage({ id: "client_template.manage_template.friendly_name_can_not_be_the_same_for_many_fields", defaultMessage: "Friendly name can not be the same for many fields." }));
    }

    this.setState({ formError: error });

    return (Object.keys(error).length > 0) ? false : true;
  };

  _handleUpdateFormState = (e) => {

    this.setState({ name: (e.currentTarget.value || "") });
  };

  //TextBox parameter value add on change event
  _setInputData = (e, isSpecialFlag, displayNumber) => {
    const { specialColumns, simpleColumns } = this.state;

    let indexInput = null;
    let tmpSpecialColmns = [];
    let tmpSimpleColmns = [];

    const name = _get(e, "currentTarget.name", "");

    if (isSpecialFlag === true) {

      tmpSpecialColmns = _cloneDeep(specialColumns || []);
      tmpSpecialColmns = (typeof tmpSpecialColmns === "object") ? Object.values(tmpSpecialColmns || []) : tmpSpecialColmns;
      tmpSpecialColmns = _reject((tmpSpecialColmns || []), _isEmpty);

      indexInput = _findIndex((tmpSpecialColmns || []), { "displayOrder": displayNumber });

      tmpSpecialColmns = _set((tmpSpecialColmns || []), `[${indexInput}].${name}`, _get(e, "currentTarget.value", ""));

      this.setState({ specialColumns: (tmpSpecialColmns || []) });

    } else if (isSpecialFlag === false) {

      tmpSimpleColmns = _cloneDeep(simpleColumns || []);
      tmpSimpleColmns = (typeof tmpSimpleColmns === "object") ? Object.values(tmpSimpleColmns || []) : tmpSimpleColmns;
      tmpSimpleColmns = _reject((tmpSimpleColmns || []), _isEmpty);

      indexInput = _findIndex((tmpSimpleColmns || []), { "displayOrder": displayNumber });

      tmpSimpleColmns = _set((tmpSimpleColmns || []), `[${indexInput}].${name}`, _get(e, "currentTarget.value", ""));

      this.setState({ simpleColumns: (tmpSimpleColmns || []) });
    }
  };

  //special column Inner TextBox parameter value add
  // _setInnerInputData = (e, displayNumber, index) => {
  //   const { simpleColumns, specialColumns } = this.state;

  //   let tmpSimpleColumns = [];
  //   let tmpSpecialColumns = [];
  //   let specialTemplate = [];
  //   let tmpColmns = [];
  //   let displayIndex = null;

  //   tmpSimpleColumns = _cloneDeep(simpleColumns || []);
  //   tmpSpecialColumns = _cloneDeep(specialColumns || []);

  //   tmpColmns = _sortBy(Object.values(tmpSimpleColumns || []).concat((Object.values(tmpSpecialColumns || []))), ["displayOrder"]);
  //   tmpColmns = _reject((tmpColmns || []), _isEmpty);

  //   displayIndex = _findIndex((tmpColmns || []), { "displayOrder": displayNumber });

  //   tmpColmns[displayIndex].columnFields[index].concatText = _get(e, "currentTarget.value", "");

  //   specialTemplate.push(..._filter((tmpColmns || []), (v) => (_isEqual(v.isSpecial, true))));

  //   this.setState({ specialColumns: (specialTemplate || []) });
  // };

  //Select parameter value add on change event
  _setDropdownValue = (selectedOptions, name, isSpecialFlag, displayNumber) => {
    const { specialColumns, simpleColumns } = this.state;

    let indexDropDown = null;
    let tmpSpecialColmns = [];
    let tmpSimpleColmns = [];

    if (isSpecialFlag === true) {

      tmpSpecialColmns = _cloneDeep(specialColumns || []);
      tmpSpecialColmns = (typeof tmpSpecialColmns === "object") ? Object.values(tmpSpecialColmns || []) : tmpSpecialColmns;
      tmpSpecialColmns = _reject((tmpSpecialColmns || []), _isEmpty);

      indexDropDown = _findIndex((tmpSpecialColmns || []), { "displayOrder": displayNumber });

      tmpSpecialColmns = _set((tmpSpecialColmns || []), `[${indexDropDown}].${name}`, (selectedOptions || null));

      this.setState({ specialColumns: (tmpSpecialColmns || []) });
    } else if (isSpecialFlag === false) {

      tmpSimpleColmns = _cloneDeep(simpleColumns || []);
      tmpSimpleColmns = (typeof tmpSimpleColmns === "object") ? Object.values(tmpSimpleColmns || []) : tmpSimpleColmns;
      tmpSimpleColmns = _reject((tmpSimpleColmns || []), _isEmpty);

      indexDropDown = _findIndex((tmpSimpleColmns || []), { "displayOrder": displayNumber });

      tmpSimpleColmns = _set((tmpSimpleColmns || []), `[${indexDropDown}].${name}`, (selectedOptions || null));

      this.setState({ simpleColumns: (tmpSimpleColmns || []) });
    }
  };

  //special column Inner DropDown parameter value add
  // _setInnerDropdownValue = (selectedOptions, displayValue, index) => {
  //   const { simpleColumns, specialColumns } = this.state;

  //   let tmpSimpleColumns = [];
  //   let tmpSpecialColumns = [];
  //   let specialTemplate = [];
  //   let tmpColmns = [];
  //   let displayIndex = null;

  //   tmpSimpleColumns = _cloneDeep(simpleColumns || []);
  //   tmpSpecialColumns = _cloneDeep(specialColumns || []);

  //   tmpColmns = _sortBy(Object.values(tmpSimpleColumns || []).concat((Object.values(tmpSpecialColumns || []))), ["displayOrder"]);
  //   tmpColmns = _reject((tmpColmns || []), _isEmpty);

  //   displayIndex = _findIndex((tmpColmns || []), { "displayOrder": displayValue });

  //   tmpColmns[displayIndex].columnFields[index].columnName = selectedOptions;

  //   const filterColumns = _filter((tmpColmns || []), (v) => (_isEqual(v.isSpecial, true)));
  //   specialTemplate.push(...filterColumns);

  //   this.setState({ specialColumns: (specialTemplate || []) });
  // };

  _removeTemplateColumn(isSpecialFlag, displayNumber) {
    const { specialColumns, simpleColumns } = this.state;

    let index = null;
    let tmpSpecialColmns = [];
    let tmpSimpleColmns = [];

    if (isSpecialFlag === true) {

      tmpSpecialColmns = _cloneDeep(specialColumns || []);

      tmpSpecialColmns = (typeof tmpSpecialColmns === "object") ? Object.values(tmpSpecialColmns || []) : tmpSpecialColmns;
      tmpSpecialColmns = _reject((tmpSpecialColmns || []), _isEmpty);

      index = _findIndex((tmpSpecialColmns || []), { "displayOrder": displayNumber });

      delete tmpSpecialColmns[index];

      this.setState({ specialColumns: (tmpSpecialColmns || []) });
    } else if (isSpecialFlag === false) {

      tmpSimpleColmns = _cloneDeep(simpleColumns || []);

      tmpSimpleColmns = (typeof tmpSimpleColmns === "object") ? Object.values(tmpSimpleColmns || []) : tmpSimpleColmns;
      tmpSimpleColmns = _reject((tmpSimpleColmns || []), _isEmpty);

      index = _findIndex((tmpSimpleColmns || []), { "displayOrder": displayNumber });

      delete tmpSimpleColmns[index];

      this.setState({ simpleColumns: tmpSimpleColmns });
    }
  };

  _handleSimpleTemplate() {
    const { simpleColumns, specialColumns, indexNo } = this.state;

    let tmpSimpleColumns = [];
    let tmpSpecialColumns = [];
    let tmpColmns = [];
    let lastColumn = [];
    let currentIndex = null;

    tmpSimpleColumns = _cloneDeep(simpleColumns || []);
    tmpSpecialColumns = _cloneDeep(specialColumns || []);

    tmpColmns = _sortBy(Object.values(tmpSimpleColumns || []).concat((Object.values(tmpSpecialColumns || []))), ["displayOrder"]);

    tmpColmns = _reject((tmpColmns || []), _isEmpty);

    lastColumn = _findLast((tmpColmns || []), (n) => {
      return n.displayOrder > indexNo
    });

    if (indexNo < (lastColumn || []).displayOrder) {

      currentIndex = (lastColumn || []).displayOrder + 1;

      this.setState(prevState => ({
        simpleColumns: {
          ...prevState.simpleColumns,
          [indexNo]: {
            ...this.defaultSimpleColumn,
            displayOrder: currentIndex
          },
        },
        indexNo: currentIndex + 1
      }))

    } else {

      this.setState(prevState => ({
        simpleColumns: {
          ...prevState.simpleColumns,
          [indexNo]: {
            ...this.defaultSimpleColumn,
            displayOrder: indexNo
          },
        },
        indexNo: indexNo + 1
      }))
    }
  };

  // _handleSpecialTemplate() {
  //   const { simpleColumns, specialColumns, indexNo } = this.state;

  //   let tmpSimpleColumns = [];
  //   let tmpSpecialColumns = [];
  //   let tmpSpColmns = [];
  //   let lastColumn = [];
  //   let currentIndex = null;

  //   tmpSimpleColumns = _cloneDeep(simpleColumns || []);
  //   tmpSpecialColumns = _cloneDeep(specialColumns || []);

  //   tmpSpColmns = _sortBy(Object.values(tmpSimpleColumns || []).concat((Object.values(tmpSpecialColumns || []))), ["displayOrder"]);

  //   tmpSpColmns = _reject((tmpSpColmns || []), _isEmpty);

  //   lastColumn = _findLast((tmpSpColmns || []), (n) => {
  //     return n.displayOrder > indexNo
  //   });

  //   if (indexNo < (lastColumn || []).displayOrder) {

  //     currentIndex = (lastColumn || []).displayOrder + 1;

  //     this.setState(prevState => ({
  //       specialColumns: {
  //         ...prevState.specialColumns,
  //         [indexNo]: {
  //           ...this.defaultSpecialColumn,
  //           displayOrder: currentIndex
  //         },
  //       },
  //       indexNo: currentIndex + 1
  //     }))

  //   } else {

  //     this.setState(prevState => ({
  //       specialColumns: {
  //         ...prevState.specialColumns,
  //         [indexNo]: {
  //           ...this.defaultSpecialColumn,
  //           displayOrder: indexNo
  //         },
  //       },
  //       indexNo: indexNo + 1
  //     }))
  //   }
  // };

  _addNewSpecialInnerRow(index) {
    const { specialColumns } = this.state;

    let tmpSpecialColmns = [];
    tmpSpecialColmns = _reject(_cloneDeep(specialColumns || []), _isEmpty);

    Object.values(tmpSpecialColmns || []).forEach(column => {

      if (column.displayOrder === index) {
        column.columnFields.push(this.defaultInnerColumnFields);
      }
    });

    this.setState({ specialColumns: _cloneDeep(tmpSpecialColmns || []) });
  };

  _minusSpecialInnerRow(index) {
    const { specialColumns } = this.state;

    let tmpSpecialColmns = [];
    tmpSpecialColmns = _reject(_cloneDeep(specialColumns || []), _isEmpty);

    Object.values(tmpSpecialColmns || []).forEach(column => {

      if ((column.displayOrder === index)) {
        column.columnFields.pop();
      }
    });

    this.setState({ specialColumns: _cloneDeep(tmpSpecialColmns || []) });
  };

  _reOrderColumns = (list, fromDisplayOrder, toDisplayOrder) => {

    let resetList = _cloneDeep(list || []);

    const [removed] = resetList.splice(fromDisplayOrder, 1);
    resetList.splice(toDisplayOrder, 0, removed);

    resetList = _reject((resetList || []), _isEmpty);

    Object.values(resetList || []).forEach((e, i) => {
      e.displayOrder = i;
    });

    return resetList;
  };

  onDragEnd = (result) => {
    const { simpleColumns, specialColumns } = this.state;

    let tmpSimpleColumns = [];
    let tmpSpecialColumns = [];
    let tmpSpColmns = [];
    let specialTemplate = [];
    let simpleTemplate = [];
    let reOrderTemplate = [];

    tmpSimpleColumns = _cloneDeep(simpleColumns || []);
    tmpSpecialColumns = _cloneDeep(specialColumns || []);

    tmpSpColmns = _sortBy(Object.values(tmpSimpleColumns || []).concat((Object.values(tmpSpecialColumns || []))), ["displayOrder"]);
    tmpSpColmns = _reject((tmpSpColmns || []), _isEmpty);

    // dropped outside the list
    if (result.destination === null) {
      return;
    }

    reOrderTemplate = this._reOrderColumns(
      tmpSpColmns,
      result.source.index,
      result.destination.index
    );

    let reArrangeSpecialTemplate = _filter((reOrderTemplate || []), (v) => (_isEqual(v.isSpecial, true)));
    specialTemplate.push(...reArrangeSpecialTemplate);

    let reArrangeSimpleTemplate = _filter((reOrderTemplate || []), (v) => (_isEqual(v.isSpecial, false)));
    simpleTemplate.push(...reArrangeSimpleTemplate);

    this.setState({ specialColumns: (specialTemplate || []), simpleColumns: (simpleTemplate || []) });
  };

  //Click on Increment button then column fields add dynamically
  // _renderInnerColumnFields(index, key) {
  //   const { masterColumnsList } = this.state;
  //   let tmpInnerColumns = [];

  //   tmpInnerColumns = _get(key, "columnFields", []);

  //   return (
  //     <>
  //       {Object.values(tmpInnerColumns || []).map((i, e) => {

  //         return (
  //           <div key={`inner-${e}`} className="row">
  //             <div key={`inner-select-${e}`} className="col-xs-4 col-sm-4 col-md-4 m-l-30 mt-1">
  //               <div className="form-group">
  //                 <Select
  //                   className="text-capitalize"
  //                   value={(i.columnName || [])}
  //                   options={(masterColumnsList || [])}
  //                   getOptionValue={(option) => (option.id)}
  //                   getOptionLabel={(option) => (option.friendly_name)}
  //                   isMulti={false}
  //                   onChange={(selectedOptions) => this._setInnerDropdownValue(selectedOptions, index, e)}
  //                 />
  //               </div>
  //             </div>
  //             <div key={`inner-text-${e}`} className="col-xs-2 col-sm-2 col-md-2 input text mt-1">
  //               <input
  //                 type="text"
  //                 name="concatText"
  //                 className="form-control"
  //                 value={(i.concatText || "")}
  //                 onChange={(k) => this._setInnerInputData(k, index, e)}
  //               />
  //             </div>
  //           </div>
  //         )
  //       })}
  //     </>
  //   )
  // }

  //Click on add button dynamically add div template
  _renderSimpleColumns(index, key, dragHandleProps) {
    const { intl } = this.props;
    const { masterColumnsList, formError } = this.state;

    return (
      <div key={`simple-${index}`} className="my-2">
        <div className="row">
          <div {...(dragHandleProps || {})} className="input text col-xs-1 col-sm-1 col-md-1 d-flex flex-column justify-content-center align-items-center cursor-pointer">
            <div>
              <img src={require("../../../../assets/icons/icon-chev-up-primary.svg").default} className="img-fluid" alt="up" />
            </div>
            <div>
              <img src={require("../../../../assets/icons/icon-chev-down-primary.svg").default} className="img-fluid" alt="down" />
            </div>
          </div>
          {/* <div className="input text col-xs-2 col-sm-2 col-md-2">
            <input
              type="text"
              name="prefix"
              className="form-control"
              value={(key.prefix || "")}
              onChange={(k) => this._setInputData(k, key.isSpecial, key.displayOrder)}
              placeholder={intl.formatMessage({ id: "client_template.manage_template.prefix", defaultMessage: "prefix" })}
            />
          </div> */}
          <div className="col-xs-5 col-sm-5 col-md-5">
            <div className="form-group">
              <Select
                className="text-capitalize"
                placeholder={intl.formatMessage({ id: "client_template.manage_template.select_column", defaultMessage: "select column" })}
                value={(key.columnName || null)}
                options={(masterColumnsList || [])}
                getOptionValue={(option) => (option.id)}
                getOptionLabel={(option) => (option.friendly_name)}
                onChange={(selectedOptions) => this._setDropdownValue(selectedOptions, "columnName", key.isSpecial, key.displayOrder)}
                isMulti={false}
              />
              {(_get(formError, `columnName-${index}`, "") !== "") && (<ErrorMessage message={_get(formError, `columnName-${index}`, "")} />)}
            </div>
          </div>
          <div className="input text col-xs-5 col-sm-5 col-md-5">
            <input
              type="text"
              name="friendlyName"
              className="form-control"
              value={(key.friendlyName || "")}
              onChange={(k) => this._setInputData(k, key.isSpecial, key.displayOrder)}
            />
            {(_get(formError, `friendlyName-${index}`, "") !== "") && (<ErrorMessage message={_get(formError, `friendlyName-${index}`, "")} />)}
          </div>
          <div className="col-xs-1 col-sm-1 col-md-1 mt-2" onClick={() => this._removeTemplateColumn(key.isSpecial, key.displayOrder)}>
            <img src={require("../../../../assets/icons/icon-close.svg").default} className="img-fluid" alt="img" />
          </div>
        </div>
      </div>
    )
  };

  //click on add Special button Dynamically div template add
  // _renderSpecialColumns(index, key) {
  //   const { formError } = this.state;

  //   return (
  //     <div key={`div-${index}`} className="my-2">
  //       <div className="row">
  // <img src={require("../../../../assets/icons/icon-chev-up-primary.svg").default} className="img-fluid arrow-up" alt="up" />
  // <img src={require("../../../../assets/icons/icon-chev-down-primary.svg").default} className="img-fluid arrow-down" alt="down" />
  //         <div className="col-xs-7 col-sm-7 col-md-7">
  //           <div className="form-group">
  //             <Select
  //               className="text-capitalize"
  //               value={(key.concatType || null)}
  //               options={(concatenateTypeList || [])}
  //               getOptionValue={(e) => (e.id || 0)}
  //               getOptionLabel={(e) => (e.name || "")}
  //               onChange={(selectedOptions) => this._setDropdownValue(selectedOptions, "concatType", key.isSpecial, key.displayOrder)}
  //               isMulti={false}
  //             />
  //           </div>
  //         </div>
  //         <div className="input text col-xs-3 col-sm-3 col-md-3">
  //           <input
  //             type="text"
  //             name="friendlyName"
  //             className="form-control"
  //             value={(key.friendlyName || "")}
  //             onChange={(k) => this._setInputData(k, key.isSpecial, key.displayOrder)}
  //           />
  //           {(_get(formError, `specialFriendly-${index}`, "") !== "") && (<ErrorMessage message={_get(formError, `specialFriendly-${index}`, "")} />)}
  //         </div>
  //         <div className="col-xs-1 col-sm-1 col-md-1 m-t-8" onClick={() => this._removeTemplateColumn(key.isSpecial, key.displayOrder)}>
  //           <i className="far fa-times-circle fa-2x add-minus-icon" />
  //         </div>
  //       </div>

  //       {this._renderInnerColumnFields(index, key)}

  //       <div className="row">
  //         <div className="col-xs-12 col-sm-12 col-md-12 mt-1">
  //           <span onClick={() => this._addNewSpecialInnerRow(index)}>
  //             <img src={require("../../../../assets/icons/icon-plus.svg").default} className="img-fluid" alt="img" />
  //           </span>
  //           <span className="ms-2" onClick={() => this._minusSpecialInnerRow(index)}>
  //             <img src={require("../../../../assets/icons/icon-minus.svg").default} className="img-fluid" alt="img" />
  //           </span>
  //         </div>
  //       </div>
  //     </div>
  //   )
  // };

  // Show all the field columns
  _renderColumns() {
    const { simpleColumns, specialColumns } = this.state;

    let tmpSimpleColumns = [];
    let tmpSpecialColumns = [];
    let tmpColmns = [];

    tmpSimpleColumns = _cloneDeep(simpleColumns || []);
    tmpSimpleColumns = (typeof tmpSimpleColumns === "object") ? Object.values(tmpSimpleColumns || []) : tmpSimpleColumns;

    tmpSpecialColumns = _cloneDeep(specialColumns || []);
    tmpSpecialColumns = (typeof tmpSpecialColumns === "object") ? Object.values(tmpSpecialColumns || []) : tmpSpecialColumns;

    tmpColmns = _sortBy(Object.values(tmpSimpleColumns || []).concat((Object.values(tmpSpecialColumns || []))), ["displayOrder"]);

    return (
      <DragDropContext onDragEnd={(e) => this.onDragEnd(e)}>
        <Droppable droppableId="droppable">
          {(provided) => (
            <div className="col-xs-12 col-sm-12 col-md-12 my-2"
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {((tmpColmns || []).map((e, i) => {
                if (typeof e === "object") {
                  return (
                    <Draggable key={`item-${e.displayOrder}`} draggableId={`item-${e.displayOrder}`} index={e.displayOrder}>
                      {(provided) => (
                        <div key={`item-drag-${i}`}
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                        >
                          {this._renderSimpleColumns(e.displayOrder, e, provided.dragHandleProps)}
                        </div>
                      )}
                    </Draggable>
                  );
                }
                return null
              }))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  };

  render() {
    const { filterAgencyList, editTemplateId, intl } = this.props;
    const { name, formError, simpleColumns, specialColumns, filterClientList, selectedClient, selectedAgency } = this.state;

    let combinedTemplate = _sortBy(Object.values(_cloneDeep(simpleColumns || [])).concat((Object.values(_cloneDeep(specialColumns || [])))), ["displayOrder"]);
    combinedTemplate = _reject((combinedTemplate || []), _isEmpty);

    return (
      <div className="row">
        <div className="col-sm-4 col-md-4">
          <div className="form-group">
            <label className="text-capitalize">
              <FormattedMessage id="client_template.manage_template.input_name" defaultMessage="Name" />
            </label>
            <div className="input text">
              <input
                type="text"
                name="name"
                className="form-control"
                value={(name || "")}
                onChange={(e) => this._handleUpdateFormState(e)} />
              {(formError.name !== "") && (<ErrorMessage message={formError.name} />)}
            </div>
          </div>
        </div>
        <div className="col-sm-4 col-md-4">
          <div className="form-group">
            <label className="text-capitalize">
              <FormattedMessage id="client_template.manage_template.agency" defaultMessage="Agency" />
            </label>
            <Select
              className="text-capitalize"
              placeholder={intl.formatMessage({ id: "client_template.manage_template.select_agency", defaultMessage: "Select agency" })}
              value={(selectedAgency || [])}
              options={(filterAgencyList || [])}
              getOptionValue={(option) => (option.id)}
              getOptionLabel={(option) => (option.agency_name)}
              onChange={(y) => this.setState({ selectedAgency: (y) })}
              isMulti={false}
              isDisabled={(editTemplateId) ? true : false}
            />
            {(formError.selectedAgency !== "") && (<ErrorMessage message={formError.selectedAgency} />)}
          </div>
        </div>
        <div className="col-sm-4 col-md-4">
          <div className="form-group">
            <label className="text-capitalize">
              <FormattedMessage id="client_template.manage_template.client" defaultMessage="Client" />
            </label>
            <Select
              className="text-capitalize"
              placeholder={intl.formatMessage({ id: "client_template.manage_template.select_client", defaultMessage: "Select Client" })}
              value={(selectedClient || [])}
              options={(filterClientList || [])}
              getOptionValue={(option) => (option.id)}
              getOptionLabel={(option) => (option.client_name)}
              onChange={(y) => this.setState({ selectedClient: (y) })}
              isMulti={false}
              isDisabled={(editTemplateId) ? true : false}
            />
            {(formError.selectedClient !== "") && (<ErrorMessage message={formError.selectedClient} />)}
          </div>
        </div>

        {((combinedTemplate || []).length > 0) && (
          <div className="col-sm-12 col-md-12 mt-5">
            <div className="cardBox-header row">
              <div className="col-xs-1 col-sm-1 col-md-1 text-capitalize p-l-32" />
              <div className="col-xs-5 col-sm-5 col-md-5 text-capitalize p-l-32">
                <h5><FormattedMessage id="client_template.manage_template.hermes_field" defaultMessage="Hermes Field" /></h5>
              </div>
              <div className="col-xs-5 col-sm-5 col-md-5 text-capitalize p-l-32">
                <h5><FormattedMessage id="client_template.manage_template.friendly_name" defaultMessage="Friendly Name" /></h5>
              </div>
            </div>
          </div>
        )}

        {this._renderColumns()}
        <div className="col-sm-12 col-md-12 py-5">
          <div className="form-group m-t-15 text-left">
            <button type="submit" className="btn btn-dark me-5" onClick={() => this._handleSimpleTemplate()}>
              <FormattedMessage id="client_template.manage_template.btn.add" defaultMessage="+ Add" />
            </button>
          </div>
        </div>
        <div className="col-sm-12 col-md-12">
          <div className="form-group text-end">
            <button type="submit" className="btn btn-primary" onClick={() => this._handleSubmit()}>
              <FormattedMessage id="btn.submit" defaultMessage="Submit" />
            </button>
          </div>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  updatePageLevelLoadingState: (data) => dispatch(updatePageLevelLoadingState(data))
});

export default withRouter(connect(null, mapDispatchToProps)(injectIntl(AddOrUpdateTemplate)));
